module.exports = __webpack_public_path__ + "static/media/cardigan.6c596a9d.jpg";